module.exports = __webpack_public_path__ + "img/trial_whitening_202410.cba475a7.jpg";